import { render, staticRenderFns } from "./SchoolTeacherLeaveApplicationControl.vue?vue&type=template&id=aedb968e&scoped=true&"
import script from "./SchoolTeacherLeaveApplicationControl.vue?vue&type=script&lang=js&"
export * from "./SchoolTeacherLeaveApplicationControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedb968e",
  null
  
)

export default component.exports